import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "_flex _gap-2 _shrink-0 _ai-sf" }
const _hoisted_2 = {
  key: 0,
  class: "gfua-screen__dropdown-wrapper"
}
const _hoisted_3 = {
  class: "gfu-balloon__content",
  "data-qa": "action-balloon-content"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_toggle_trigger = _resolveComponent("toggle-trigger")
  const _component_toggle_content = _resolveComponent("toggle-content")
  const _component_toggle_container = _resolveComponent("toggle-container")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.screenActions, (action) => {
      return (_openBlock(), _createBlock(_component_tooltip, {
        key: action.key,
        enabled: action.tooltipVisibility,
        text: action.tooltipText
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(action.component), _mergeProps({ ref_for: true }, action.props, {
            onClick: _withModifiers(action.fn, ["prevent"])
          }), {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(action.buttonText), 1 /* TEXT */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["onClick"]))
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["enabled", "text"]))
    }), 128 /* KEYED_FRAGMENT */)),
    ($options.hasBallon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_toggle_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_toggle_trigger, {
                tag: "button",
                class: _normalizeClass($options.ballonButtonClasses),
                "active-class": "gfu-table__button--selected",
                "data-qa": "toggle-trigger-action:button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_icon, { name: "ellipsis-v" })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["class"]),
              _createVNode(_component_toggle_content, {
                tag: "div",
                tabindex: "0",
                class: "gfu-balloon gfu-balloon--right gfu-balloon--no-header gfua-screen__dropdown is-hidden",
                "active-class": "is-open",
                "close-on-click": ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.screenBalloonActions, (action) => {
                      return (_openBlock(), _createBlock(_resolveDynamicComponent(action.component), _mergeProps({
                        key: action.key
                      }, { ref_for: true }, action.props, {
                        onClick: _withModifiers(action.fn, ["prevent"])
                      }), {
                        default: _withCtx(() => [
                          _createVNode(_component_base_icon, {
                            class: "gfu-balloon__content-icon",
                            "is-fixed-width": true,
                            name: action.icon
                          }, null, 8 /* PROPS */, ["name"]),
                          _createTextVNode(" " + _toDisplayString(action.actionText), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}